import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

const MAX_WIDTH = 200;

class SectorName extends PureComponent {
  getWidth = () => {
    const { width } = this.props;

    return width - 3; // minus td padding
  };

  getStyle = () => ({
    whiteSpace: 'nowrap',
    width: Math.max(this.getWidth(), MAX_WIDTH),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  });

  render() {
    const { children, width } = this.props;
    if (!width) {
      return null;
    }
    return (
      <div style={this.getStyle()} className="top-mover-sector-name">
        {children}
      </div>
    );
  }
}

SectorName.propTypes = {
  width: PropTypes.number,
  children: PropTypes.node,
};

export default SectorName;
